import React  from 'react';  

export const signpostingConfig = [
 
  {
    auth: ['user'],
    routes: [
      {
        path: '/signposting',
        component: React.lazy(() => import('./AppSignposting')),
      },
    ],
  },
 
];
